import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type MerchantPausedFeatureId = ID<"merchantPausedFeature">;
export const merchantPausedFeatureIdFormat = idFormat<MerchantPausedFeatureId>({
  prefix: "mpf_",
});
